function AnciensClients() {
  const Clients = ['./images/logo_thales.svg', './images/logo_airbus.svg', './images/logo_lectra.svg', './images/logo_anr.svg', './images/logo_xplearn.svg', './images/logo_endocardites.svg', './images/logo_cap_emploi_gironde.svg', './images/logo_snsolutions.svg', './images/logo_madic_industries.svg', './images/logo_thermo_fisher_scientific.svg', './images/logo_r3mob.svg'];

  const listeClients = Clients.map((client) => {
    return (
      <li>
        <img src={client} alt="" />
      </li>
    );
  });

  return (
    <div>
      <h3 className="px-6 text-gris-sombre dark:text-blanc-sombre text-[40px] font-extrabold text-center">
        Ils nous ont fait <span className="text-bleu-je">confiance</span>
      </h3>
      <div
        x-data="{}"
        x-init="$nextTick(() => {
        let ul = $refs.logos;
        ul.insertAdjacentHTML('afterend', ul.outerHTML);
        ul.nextSibling.setAttribute('aria-hidden', 'true');
    })"
        class="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">{listeClients}</ul>
        <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll" aria-hidden="true">
          {listeClients}
        </ul>
      </div>
    </div>
  );
}

export default AnciensClients;